

import { reactive, defineComponent, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import dicts from '@/utils/dicts'

export default defineComponent({
  props: {
    title: {
      type: String
    },
    showTime: {
      type: Boolean,
      default: true
    },
    smallTitle: {
      type: String,
    },
    icon: {
      type: Boolean,
      default: false
    },
    isJump: {
      type: String,
      default: ''
    },
    isEmitJump: {
      type: Boolean,
      default: false
    },
    toNewList: {
      type: Boolean,
      default: false
    },
    timeKey: {
      type: String,
      default: ''
    },
    initIdx: {
      type: Number,
      default: 0
    },
  },
  setup(props, context) {
    const route = useRoute();
    const isSpecial = route.query.isSpecial;
    const isBuyFlag = route.query.isBuyFlag;
    const timeLevel = route.query.timeLevel as any;
    const beginDate = route.query.beginDate;
    const endDate = route.query.endDate;
    let selectedTime = isSpecial ? Number(timeLevel) === 5 ? [beginDate, endDate] : [] : [];
    let newSpTimeLevel = isSpecial ? Number(timeLevel) : 0;
    let newSpShowTimeSelect = isSpecial ? Number(timeLevel) === 5 ? true : false : false;
    if(isBuyFlag) {
      newSpTimeLevel = Number(timeLevel) + 1;
      newSpShowTimeSelect = ((Number(timeLevel) + 1) === 5) ? true : false;
      selectedTime = ((Number(timeLevel) + 1) === 5) ? [beginDate, endDate] : [];
    }
    const dataMap = reactive({
      dicts,
      dstxActive  : newSpTimeLevel,
      showTimeSelect: newSpShowTimeSelect,
      selectTime: selectedTime,

      swichItem: (idx: any) => {
        dataMap.dstxActive = idx
        dataMap.showTimeSelect = idx === 5 ? true : false
        if(idx !== 5){
          dataMap.selectTime = [];
        }
        if( props.timeKey === 'custom' ){
          idx !== 5 && context.emit('change', dicts.timeSelection[idx])
        }else{
          idx !== 5 && context.emit('change', props.timeKey ? {timeLevel: dicts.timeSelection[idx][props.timeKey]} : {timeLevel: dicts.timeSelection[idx].value})
        }
      },
      getTime: (val:any) => {
        context.emit('change', {
          timeLevel: 0,
          dateFrom: window.moment(val[0]).format('YYYY-MM-DD'),
          dateTo: window.moment(val[1]).format('YYYY-MM-DD'),
        })
      }
    })

    if( props.initIdx === 0 || props.initIdx ){
      dataMap.dstxActive = props.initIdx
    }

    const handleJump = (name:any) => {
      if( props.isJump ){
        if(props.toNewList) {
          if( dataMap.showTimeSelect ){
            const beginDate = window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD')
            const endDate = window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD')
            window.open(`/investment/agency/buy-rating?timeLevel=${dataMap.dstxActive - 1}&isBuyFlag=1&beginDate=${beginDate}&endDate=${endDate}`)
          }else{
            window.open(`/investment/agency/buy-rating?timeLevel=${dataMap.dstxActive - 1}&isBuyFlag=1`)
          }
        }else {
          if( dataMap.showTimeSelect ){
            const beginDate = window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD')
            const endDate = window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD')
            window.open(`/investment/agency/index?idx=${props.isJump}&timeLevel=${dataMap.dstxActive - 1}&beginDate=${beginDate}&endDate=${endDate}&organizationSName=${name}`)
          }else{
            window.open(`/investment/agency/index?idx=${props.isJump}&timeLevel=${dataMap.dstxActive - 1}&organizationSName=${name}`)
          }
        }
      }
      if(props.isEmitJump) {
        if(dataMap.showTimeSelect) {
          const beginDate = window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD')
          const endDate = window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD')
          context.emit('goToList', { beginDate: beginDate, endDate: endDate, timeLevel: dataMap.dstxActive  })
        }else {
          context.emit('goToList', { timeLevel: dataMap.dstxActive  })
        }
      }
    }

    const handleJump2 = (name:any) => {
      if( props.isJump ){
        if( dataMap.showTimeSelect ){
          const beginDate = window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD')
          const endDate = window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD')
          window.open(`/investment/agency/index?idx=${props.isJump}&timeLevel=${dataMap.dstxActive - 1}&beginDate=${beginDate}&endDate=${endDate}&orgSName=${name}`)
        }else{
          window.open(`/investment/agency/index?idx=${props.isJump}&timeLevel=${dataMap.dstxActive - 1}&orgSName=${name}`)
        }
      }
    }

    const setTime = (param:any) => {
      // console.log(param,dicts.timeSelection)
      dicts.timeSelection.map((item:any, idx:any)=>{
        if( item.timeLevel === param ){
          dataMap.dstxActive = idx
          console.log(dicts.timeSelection[idx])
          context.emit('change', dicts.timeSelection[idx], true)
        }
      })
    }

    if(isSpecial) {
      const newTimeLevel = Number(timeLevel) === 5 ? 0 : dicts.timeSelection[Number(timeLevel)].value;
      context.emit('change', {
        timeLevel: newTimeLevel,
        dateFrom: dataMap.selectTime[0] && window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD'),
        dateTo: dataMap.selectTime[0] && window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD'),
      })
    }else if(isBuyFlag){
      const newTimeLevel = (Number(timeLevel) + 1) === 5 ? 0 : dicts.timeSelection[Number(timeLevel) + 1].value;
      context.emit('change', {
        timeLevel: newTimeLevel,
        dateFrom: dataMap.selectTime[0] && window.moment(`${dataMap.selectTime[0]}`).format('YYYY-MM-DD'),
        dateTo: dataMap.selectTime[0] && window.moment(`${dataMap.selectTime[1]}`).format('YYYY-MM-DD'),
      })
    }else {
      if( props.timeKey === 'custom' ){
        context.emit('change', dicts.timeSelection[dataMap.dstxActive])
      }else{
        context.emit('change', props.timeKey ? {timeLevel: dicts.timeSelection[dataMap.dstxActive][props.timeKey]} : {timeLevel: -1})
      }
    }
    
    return { ...toRefs(dataMap),handleJump,handleJump2,setTime }
  }
})
